module.exports = __webpack_public_path__ + "img/lemon01_300px.2d990076.jpg";